import React, { FC } from 'react'

import { PageContent } from 'common'
import { MenuItemButton } from 'components/menu-item-button'

import { EntityMenuContainer } from '../styles/EntityMenu.styles'
import { EntityMenuBottomSheet } from './EntityMenuBottomSheet'
import { TEntityMenuViewProps } from '../types'

export const EntityMenuView: FC<TEntityMenuViewProps> = ({
  infoBottomsheet,
  showBottomsheet,
  entities,
  menuOptions,
  bottomsheetClickHandler,
  onClick,
}) => (
  <PageContent>
    <EntityMenuContainer>
      {menuOptions.map((item) => {
        if (entities.includes(item.id)) {
          const menuItemClickHandler = () => onClick(item.id, item.route)

          return <MenuItemButton key={item.title} {...item} onClick={menuItemClickHandler} />
        }

        return null
      })}
    </EntityMenuContainer>
    {showBottomsheet && (
      <EntityMenuBottomSheet
        bottomsheetClickHandler={bottomsheetClickHandler}
        infoBottomsheet={infoBottomsheet}
      />
    )}
  </PageContent>
)
